import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 `page_view` event on every client-side route change. The
// initial pageview is sent automatically by the `gtag('config', 'G-…')`
// call in index.html, so we skip the first location to avoid duplicates.
const GA_MEASUREMENT_ID = "G-17EM38B3KQ";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function PageviewTracker() {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (typeof window.gtag !== "function") return;
    const pagePath = location.pathname + location.search;
    window.gtag("event", "page_view", {
      send_to: GA_MEASUREMENT_ID,
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
